import { useGlobalState } from 'context/GlobalStateContext'
import {
  PayItemConnectionsQuery,
  PayItemConnectionsQueryResult,
  usePayItemConnectionsQuery,
} from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { DefaultOptionType } from 'components/CIMSSelect/types'

export type PayItemConnection =
  PayItemConnectionsQuery['project']['payItemConnections'][0]
type ConnectionsContext = Pick<PayItemConnectionsQueryResult, 'refetch'> & {
  data: PayItemConnection[] | undefined
  fetching: PayItemConnectionsQueryResult['loading']
  groups: DefaultOptionType[]
}

const { Provider, useContextFn } =
  createStrictContext<ConnectionsContext>('ConnectionsContext')

export const useConnectionsContext = useContextFn

const ConnectionsProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const {
    data,
    loading: fetching,
    refetch,
  } = usePayItemConnectionsQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const groups = useOptions({
    items: data?.project?.payItemConnectionGroups,
    label: 'name',
    tooltip: 'description',
    value: 'id',
    sort: 'name',
  })
  return (
    <Provider
      value={{
        data: data?.project?.payItemConnections,
        groups,
        fetching,
        refetch,
      }}
    >
      {children}
    </Provider>
  )
}

export default ConnectionsProvider
